import { render, staticRenderFns } from "./ImproveYN.vue?vue&type=template&id=54c6c06d"
import script from "./ImproveYN.vue?vue&type=script&lang=js"
export * from "./ImproveYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports